<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="button.return" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
      </template>
      <template #extra>
        <vxe-button :disabled="warehouse.isNew()" content="button.refresh" icon="vxe-icon-refresh" mode="text" status="danger" @click="refresh(warehouse.id)"/>
        <vxe-button content="button.save" icon="vxe-icon-save" mode="text" status="primary" @click="save"/>
      </template>
      <a-form-model ref="form" :colon="false" :label-col="{span:8}" :model="warehouse" :rules="rules" :wrapper-col="{span:16}">
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.no')" prop="no">
              <vxe-input v-model="warehouse.no" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.name')" prop="name">
              <vxe-input v-model="warehouse.name" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.orderStrategy')">
              <vxe-select v-model="warehouse.orderStrategy.id" :options="orderStrategies" style="width: 100%" @change="onOrderStrategyChange"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.waveStrategy')">
              <vxe-select v-model="warehouse.waveStrategy.id" :options="waveStrategies" style="width: 100%" @change="onWaveStrategyChange"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.pickingContainerType')">
              <vxe-select v-model="warehouse.pickingContainerType.id" :options="containerTypes" style="width: 100%" @change="onContainerTypeChange"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.additionPickingMode')">
              <vxe-select v-model="warehouse.additionPickingMode" :options="additionPickingModes" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.weightDeviation')">
              <vxe-number-input v-model="warehouse.weightDeviation" :min="1" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.taskPrebuilt')" :label-col="{span:16}" :wrapper-col="{span:8}">
              <vxe-switch v-model="warehouse.taskPrebuilt"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.orderSplitting')" :label-col="{span:16}" :wrapper-col="{span:8}">
              <vxe-switch v-model="warehouse.orderSplitting"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.maker')">
              <vxe-input v-model="warehouse.maker" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.receiver')">
              <vxe-input v-model="warehouse.receiver" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.inspector')">
              <vxe-input v-model="warehouse.inspector" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.shelver')">
              <vxe-input v-model="warehouse.shelver" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.closer')">
              <vxe-input v-model="warehouse.closer" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.dispatcher')">
              <vxe-input v-model="warehouse.dispatcher" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.issuer')">
              <vxe-input v-model="warehouse.issuer" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.picker')">
              <vxe-input v-model="warehouse.picker" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.seeder')">
              <vxe-input v-model="warehouse.seeder" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.packer')">
              <vxe-input v-model="warehouse.packer" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.reviewer')">
              <vxe-input v-model="warehouse.reviewer" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.deliver')">
              <vxe-input v-model="warehouse.deliver" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col :span="24">
            <a-form-model-item :label="$t('business.label.owner')" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
              <vxe-select v-model="ownerIds" :options="owners" multiple style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </vxe-card>
    <address-detail ref="addressDetail" @change="onAddressChange"/>
  </div>
</template>

<script>
import Vue from 'vue'
import { ENTERPRISE } from '@/store/mutation-types'
import { findOne, save } from '@/api/Api'
import { Warehouse } from '@/api/dto/common/Warehouse'
import { Dictionary } from '@/api/dto/admin/Dictionary'
import { ContainerType } from '@/api/dto/common/ContainerType'
import AddressDetail from '@/views/basedata/address/AddressDetail.vue'

export default {
  components: { AddressDetail },
  props: {
    owners: { type: Array, default: [] },
    orderStrategies: { type: Array, default: [] },
    waveStrategies: { type: Array, default: [] },
    containerTypes: { type: Array, default: [] },
    additionPickingModes: { type: Array, default: [] }
  },
  data() {
    return {
      loading: false,
      enterprise: Vue.ls.get(ENTERPRISE),
      warehouse: new Warehouse(),
      ownerIds: [],
      rules: {
        no: [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        name: [{ required: true, message: this.$t('message.cannotBeEmpty') }]
      }
    }
  },
  methods: {
    back() {
      this.$emit('back')
    },
    onOrderStrategyChange(event) {
      this.warehouse.orderStrategy = new Dictionary({ id: event.value })
    },
    onWaveStrategyChange(event) {
      this.warehouse.waveStrategy = new Dictionary({ id: event.value })
    },
    onContainerTypeChange(event) {
      this.warehouse.pickingContainerType = new ContainerType({ id: event.value })
    },
    onAddressChange(value) {
      this.warehouse.address = value
    },
    build(result) {
      this.warehouse = new Warehouse(result)
      this.ownerIds = result && result.owners ? result.owners.map(item => item.id) : []
      if (!this.warehouse.address.isNew()) this.$refs.addressDetail.refresh(this.warehouse.address.id)
    },
    refresh(id, copy) {
      this.loading = true
      findOne('warehouseFactory', { id: id }).then(res => {
        if (res.success) {
          if (copy) {
            res.result.id = undefined
            res.result.version = undefined
          }
          this.build(res.result)
        }
      }).finally(() => this.loading = false)
    },
    add() {
      this.build()
      this.warehouse.available = true
    },
    save() {
      this.$refs.form.validate((success) => {
        if (success) {
          this.loading = true
          const warehouse = this.warehouse.toJSONObject()
          warehouse.enterprise = this.enterprise
          warehouse.owners = this.ownerIds ? this.ownerIds.map(item => {
            return { id: item }
          }) : []
          save('warehousePersister', warehouse).then(res => {
            if (res.success) {
              this.build(res.result)
              this.$message.success(this.$t('message.saveSuccess'))
            }
          }).finally(() => this.loading = false)
        }
      })
    }
  }
}
</script>